import { fetchUser } from '@/api/business/user'
import { useQuery } from '@tanstack/react-query'

export const UserKeys = {
    all: ['users'] as const,
    lists: () => [...UserKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...UserKeys.lists(), page, perPage, filters] as const,
    details: () => [...UserKeys.all, 'detail'] as const,
    detail: (params: string) => [...UserKeys.details(), params] as const,
}

export const useUserQuery = () => {
    return useQuery({
        queryFn: fetchUser,
        queryKey: UserKeys.lists(),
    })
}
